import {
  PortableText,
  PortableTextBlock,
  PortableTextBlockComponent,
  PortableTextListComponent,
} from '@portabletext/react'

import { CompareCredit } from '../../../../types'
import { Heading3 } from '../heading3'
import { Normal } from '../normal'
import { ListBullet } from '../listBullet'
import { ListNumber } from '../listNumber'
import { AttributeRenderer } from './shared'

export const DefaultLayout: React.FC<{
  content: PortableTextBlock[]
  referencedCards: null | Record<string, CompareCredit.Entity>
}> = ({ content, referencedCards }) => {
  return (
    <PortableText
      value={content}
      components={{
        block: {
          h3: Heading3 as PortableTextBlockComponent,
          normal: Normal as PortableTextBlockComponent,
        },
        types: {
          advertorialAttribute: AttributeRenderer(referencedCards),
        },
        list: {
          number: ListNumber as PortableTextListComponent,
          bullet: ListBullet as PortableTextListComponent,
        },
      }}
    />
  )
}
